export var NetboxStatusEvent;
(function (NetboxStatusEvent) {
    NetboxStatusEvent["Init"] = "netbox.status.init";
    NetboxStatusEvent["Get"] = "netbox.status.get";
    NetboxStatusEvent["Send"] = "netbox.status.send";
})(NetboxStatusEvent || (NetboxStatusEvent = {}));
